"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.inputHeaderPropTypes = void 0;
var _stencilReactDesc = require("@amzn/stencil-react-desc");
var _tooltip = require("../../tooltip");
const inputHeaderPropTypes = exports.inputHeaderPropTypes = {
  error: _stencilReactDesc.PropTypes.bool.description('Whether the form element currently has an error.'),
  htmlFor: _stencilReactDesc.PropTypes.string.isRequired.description('The id of the form element this component is labelling.'),
  labelId: _stencilReactDesc.PropTypes.string.description('The id to apply to the label element.'),
  labelText: _stencilReactDesc.PropTypes.string.isRequired.description('Label text to display.'),
  renderLabel: _stencilReactDesc.PropTypes.func.description('Render function to customize how the label renders based on the other props.').format("({\n  children: node,\n  color: string,\n  htmlFor: string,\n  labelId?: string\n}) => node"),
  descriptionText: _stencilReactDesc.PropTypes.string.description('Description text that will be displayed under the label.'),
  descriptionId: _stencilReactDesc.PropTypes.string.description('The id to apply to the description element.'),
  required: _stencilReactDesc.PropTypes.bool.description('Whether the form element is required.'),
  tooltipAlignment: _stencilReactDesc.PropTypes.oneOf(Object.values(_tooltip.TooltipAlignment)).description('Sets the tooltip alignment.'),
  tooltipAltText: _stencilReactDesc.PropTypes.string.description('Alt text for the tooltip.'),
  tooltipText: _stencilReactDesc.PropTypes.string.description('Text to display in a tooltip beside the label.'),
  warning: _stencilReactDesc.PropTypes.bool.description('Whether the form element currently has a warning.')
};